import axios from 'axios'
import {Toast} from 'vant'
import {MAP_LIST} from './ajaxMap'
import {createBody, createSign, decryptResponse} from './signValidate'
import ajaxNormal from "./ajax";
import cryptojs from "crypto-js";
import store from '@/store'
import md5 from "js-md5";

let ajaxCount = 0
let ApiUrl = 'jklw-gateway'

// 网关请求方式
export default function ajaxNet(params) {
  let method = params.method || 'post',
    transNO = params.transNO || '', // 交易号
    tempParams = params.params,
    restfulURL = MAP_LIST[params.transNO] || '',
    baseURL = '',
    axParams = {},
    timestamp = new Date().getTime().toString(), // 时间戳
    // 处理正式入参
    constVal = {
      val1: 'wxgzh', // userId
      val2: 'wxgzh' // password
    },
    nonce = randomNum(5) + timestamp,
    requestData = createBody(tempParams),
    singBody = method.toUpperCase() === 'GET' ?
      'body' +  requestData:
      JSON.stringify({body: requestData}),
    headers = {
      // 'Content-Type': 'application/json;charset=UTF-8',
      appToken: common.getSession('appToken'),
      ecToken: common.getSession('ecToken'),
      'Kt-Decode-2': true,
      userid: constVal.val1,
      password: constVal.val1,
      transNo: transNO,
      timestamp,
      nonce,
      sign: createSign(`nonce${nonce}timestamp${timestamp}transNo${transNO}userid${constVal.val1}${singBody}${constVal.val2}`)
    }

  // 处理请求url
  if (restfulURL.indexOf('/api')!==-1) {
    restfulURL = '/userApi' + restfulURL
    if (common.getStorage('token') || common.getStorage('userId')) {
      headers['Authorization'] = common.getStorage('token') || ''
    }
    let timestamp1 = new Date().getTime()
    let sortedKeys  = Object.keys(tempParams).sort();
    let sortedObj = {};
    sortedKeys .forEach(key => {
      if (tempParams[key] || tempParams[key] === 0) {
        sortedObj[key] = tempParams[key]
      }
    });
    const appid = 'jtpt03'
    const appSecret = 'LinghuSMS3_'
    const nonce = md5(timestamp1.toString())
    const signatureInfo = 'appid=' + appid +
      'appsecret=' + appSecret +
      'nonce=' + nonce +
      (method === 'post' ? ('params=' + JSON.stringify(sortedObj)) : '') +
      'timestamp=' + timestamp1.toString()
    headers['userapi-validate-appid'] = appid
    headers['userapi-validate-timestamp'] = timestamp1
    headers['userapi-validate-nonce'] = nonce
    headers['userapi-validate-signature'] = md5(signatureInfo)
  }
  else if (restfulURL === '') {
    restfulURL = '/csb/CsbBusService.asmx/ProcessJson'
  }

  if (store.getters.getEncryptRandom) {
    headers['random-code'] = store.getters.getEncryptRandom
  }

  axParams = {
    baseURL,
    url: ApiUrl + restfulURL,
    method,
    timeout: 20000,
    headers,
    params: method.toUpperCase() === 'GET' ? { body: requestData} : '',
    data: method.toUpperCase() === 'GET' ? null : {body: requestData}
  }

  if (params.isLoading !== false) {
    // Toast.clear();
    if (ajaxCount === 0) {
      Toast.loading({ message: '请稍等', duration: 0, forbidClick: true })
    }
    ajaxCount++
  }

  return new Promise((resolve, reject) => {
    axios(axParams)
      .then(res => {
        ajaxCount--
        if (ajaxCount <= 0) {
          Toast.clear()
          ajaxCount = 0
        }

        let response
        if (restfulURL.indexOf('/csb/') !== -1) {
          // --------esb
          let resData = decryptResponse(res.data.data),
            tempRes = resData
              .replace('<?xml version="1.0" encoding="utf-8"?>', '')
              .replace('<string xmlns="http://tempuri.org/">', '')
              .replace('<string xmlns="http://tempuri.org/" />', '')
              .replace('</string>', ''),
            body = JSON.parse(tempRes)
          if (['PeisService', 'getPerIndex'].indexOf(transNO) !== -1) {
            resolve(body)
            return
          } else {
            response = body.body.response
          }
        }
        else if (restfulURL.indexOf('/api')!==-1) {
          console.log('aaa', restfulURL)
          res.data.data = JSON.parse(decryptResponse(res.data.data))
          console.log('bbb', res.data.data)
          if (res.data.code && res.data.code.toString() === '200') {
            resolve(res.data)
          } else {
            if (!params.toast && restfulURL.indexOf('verifyToken') === -1) Toast.fail(res.data.message)
            reject(res.data)
          }
        }
        else if (transNO === 'getKey') {
          response = res.data
          if (Number(response.code) === 0) {
            resolve(response)
          } else {
            if (!params.toast) Toast.fail(res.data.msg)
            reject(res.data)
          }
          return
        }
        else {
          // ---------非esb
          response = JSON.parse(decryptResponse(res.data.data))
        }

        // 根据结果进行返回
        if (response) {
          // console.log('response:', response)
          resolve(response)
        } else {
          if (!params.toast) Toast.fail(response.msg)
          reject(response)
        }
      })
      .catch(error => {
        // Toast.clear();
        ajaxCount--
        if (ajaxCount === 0) {
          Toast.clear()
        }
        console.log(error.message)
        reject(error)
      })
  })
}

// 生成n位数字字符串
function randomNum(n) {
  let res = ''
  for (let i = 0; i < n; i++) {
    res += Math.floor(Math.random() * 10)
  }
  return res
}

export function encryptAes(string) {
  console.log(string)
  let encrypt = cryptojs.AES.encrypt(
    JSON.stringify(string),
    cryptojs.enc.Utf8.parse('KingTangKingTang'),
    {
      mode: cryptojs.mode.ECB,
      padding: cryptojs.pad.Pkcs7
    });
  let encryptStr = encrypt.ciphertext.toString(cryptojs.enc.Hex)
  console.log(encryptStr)
  return encryptStr
}

export function decryptAes(string) {
  let secretkey = 'KingTangKingTang'
  let hexStr = cryptojs.enc.Hex.parse(string)
  let str = cryptojs.enc.Base64.stringify(hexStr)
  let decrypt = cryptojs.AES.decrypt(str, cryptojs.enc.Utf8.parse(secretkey), {
    mode: cryptojs.mode.ECB,
    padding: cryptojs.pad.Pkcs7
  })
  let decryptedStr = decrypt.toString(cryptojs.enc.Utf8)
  console.log(decryptedStr)
  return decryptedStr.toString()
}



//////////////////
// WEBPACK FOOTER
// ./static/js/ajaxGateWay.js
// module id = null
// module chunks = 